module.exports = __webpack_public_path__ + "img/tab2@2x.b077b9f4.png";